import type { RegisteredComponent } from "@builder.io/sdk-react";

import { SpenderCartSection } from "~/hec/components/spender-page/spender-sections";
import { cn } from "~/lib/ui";

/**
 * COM-258/260/263: the cart ribbon with the balance card, as an authored
 * block. Desktop: a sticky column (place it beside the grid). Phones: a
 * fixed bottom sheet wherever it sits.
 */
const SpenderCartBlock = ({
  attributes,
}: {
  attributes?: Record<string, unknown>;
}) => (
  // Full column height: the sidebar sticks within this root, not the column.
  <div
    data-testid="spender-cart-block-root"
    {...attributes}
    className={cn("md:h-full", attributes?.className as string | undefined)}
  >
    <SpenderCartSection />
  </div>
);

export const SpenderCartDefinition = {
  component: SpenderCartBlock,
  name: "SpenderCart",
  friendlyName: "FSA Spender cart and balance (FSA only)",
  noWrap: true,
  canHaveChildren: false,
} satisfies RegisteredComponent;

export default SpenderCartBlock;
